import React from "react";
import { Modal,Button} from "react-bootstrap";
function Nat5(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
          SRI Aurobindo Society
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalparas">
          <p>
           ISBM University is a member of SRI Aurobindo Society. This society intensively work to inspire the youth of India and help them find their purpose in life. It organizes and facilitates various self-development and leadership programs that aim to awaken youth and prepare themselves to live a spiritually and materially fulfilling life.
          </p>
        </Modal.Body>
      </Modal>
    );
  }

export default Nat5